const LoadingComponent = () => {
    return (
        <>
            <div className="container-vitals">
                <section className="section-vitals">
                    <div className="title-vitals mb-3">

                        <img src="/img/loading.gif" alt="Loading..." className="loading-gif" />
                    </div>

                </section>
            </div>
        </>
    );
};

export { LoadingComponent };